import { message, Select } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  ModalItem,
  FormItem,
  ButtonItem,
  InputItem,
  ErrorItem,
  SelectItem,
} from "../../../../Components/Items";

const { Option } = Select;

class EditarTipoAcumulado extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    visible: this.props.visible,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible) {
      this.setState({ visible: this.props.visible });
      if (this.props.visible && this.props.tipoAcumuladoId) {
        this.formRef.current && this.formRef.current.resetFields();
        this.consultarDatosTipoAcumulado(this.props.tipoAcumuladoId);
      }
    }
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  consultarDatosTipoAcumulado(id) {
    this.setState({ loading: true });
    axios
      .post(
        "tiposAcumulados/datosTipoAcumulado",
        { tipoAcumuladoId: id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success !== 2) {
          message.error("No se encontraron los datos del tipo de acumulado");
        } else {
          const { nombre, tipoAcumulado } = res.data.data;
          this.formRef.current && this.formRef.current.setFieldsValue({
            nombre,
            tipoAcumulado,
          });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Error al comunicarse con el servidor");
      });
  }

  onFinish(values) {
    this.setState({ loading: true });
    axios
      .post(
        "tiposAcumulados/editarTipoAcumulado",
        {
          ...values,
          tipoAcumuladoId: this.props.tipoAcumuladoId,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Tipo de acumulado actualizado exitosamente");
          this.cerrarModal();
        } else {
          message.error("No se pudo actualizar el tipo de acumulado");
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Error al comunicarse con el servidor");
      });
  }

  cerrarModal = () => {
    this.props.cerrarEditarTipoAcumulado();
    if (this.formRef.current) {
      this.formRef.current.resetFields();
    }
  };

  render() {
    return (
      <ModalItem
        title="Editar Tipo de Acumulado"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarModal}
        width={600}
      >
        <Form
          ref={this.formRef}
          name="modalEditarTipoAcumulado"
          layout
          bottom={
            <ButtonItem
              type="primary"
              htmlType="submit"
              style={{ display: "block", margin: "0 0 0 auto" }}
              loading={this.state.loading}
            >
              Guardar
            </ButtonItem>
          }
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
        >
          <FormItem
            name="nombre"
            label="Nombre del Tipo de Acumulado"
            required
            margin
          >
            <InputItem placeholder="Ingresa el nombre del tipo de acumulado" />
          </FormItem>

          <FormItem
            name="tipoAcumulado"
            label="Tipo de Acumulado"
            required
            margin
          >
            <SelectItem placeholder="Selecciona el tipo de acumulado">
              <Option value={1}>Percepción, Deducción y Obligación</Option>
              <Option value={2}>Días y Horas</Option>
            </SelectItem>
          </FormItem>
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(EditarTipoAcumulado);